import React from "react";
import { DataKindMaintenancePageInitialState, PageNewState } from ".";

export const DataKindMaintenancePageContext = React.createContext({
  pageState: DataKindMaintenancePageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
